(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_cart-title"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const btn = document.querySelector('.clear-cart');
    if (!btn) return;

    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      try {
        const res = await fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } });
        if (!res.ok) throw new Error(res.status);
        location.reload();
      } catch (err) {
        console.error('Clear cart failed:', err);
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tw-pdp-value-prop-links"] && !Shopify.designMode) return;
  try {
    function isMobile() {
    return window.innerWidth <= 768;
  }

  function openFeatureDetail(template) {
    const modal = document.getElementById('value-prop-link-modal');
    const slideout = document.getElementById('value-prop-link-slideout');
    const mask = document.getElementById('value-prop-link-slideout-mask');

    const header = document.getElementById('header-group');
    const offsetHeight = header?.getBoundingClientRect()?.height;
    const paddingAmount = 24;

    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    const mediaMatches = window.matchMedia('(min-width: 1280px)');
    const scrollY = window.scrollY;

    if (!mediaMatches.matches) {
      modal.querySelector('.modal-body').append(template?.content?.firstElementChild.cloneNode(true));

      const closeButton = modal?.querySelector('[id^="value-prop-link-close-"]');
      closeButton?.addEventListener('click', closeFeatureDetail);
      modal.classList.remove('hidden');
      modal.classList.add('flex', 'active');
      modal.setAttribute('aria-hidden', 'false');
      modal.setAttribute('data-active', 'true');
      mask.classList.add('active');
      modal.style.setProperty('--value-prop-link-visibility', 'visible');
      modal.style.setProperty('--modal-max-height', `calc(100dvh - ${paddingAmount * 2}px)`);

      modal.style.setProperty('top', scrollY + 'px');
    } else {
      slideout.querySelector('.value-prop-link-content').append(template?.content?.firstElementChild.cloneNode(true));

      const closeButton = slideout?.querySelector('[id^="value-prop-link-close-"]');
      closeButton?.addEventListener('click', closeFeatureDetail);
      slideout.classList.remove('hidden');
      slideout.classList.add('flex', 'active');
      slideout.setAttribute('data-active', 'true');
      slideout.setAttribute('aria-hidden', 'false');
      slideout.style.setProperty('--modal-max-height', `calc(100dvh - ${paddingAmount * 2}px)`);
      mask.setAttribute('data-active', 'true');
      mask.classList.add('active');
      slideout.style.setProperty('top', scrollY + 'px');

      slideout.style.setProperty('--value-prop-link-visibility', 'visible');
    }
  }

  function closeFeatureDetail() {
    const modal = document.getElementById('value-prop-link-modal');
    const slideout = document.getElementById('value-prop-link-slideout');
    const mask = document.getElementById('value-prop-link-slideout-mask');

    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';

    modal.classList.remove('active');
    modal.setAttribute('aria-hidden', 'true');
    modal.setAttribute('data-active', 'false');
    slideout.classList.remove('active');
    slideout.setAttribute('aria-hidden', 'true');
    slideout.setAttribute('data-active', 'false');
    mask.classList.remove('active');
    mask.setAttribute('data-active', 'false');
    setTimeout(() => {
      modal.classList.remove('flex');
      modal.classList.add('hidden');
      slideout.classList.remove('flex');
      slideout.classList.add('hidden');
      modal.style.setProperty('--value-prop-link-visibility', 'hidden');
      slideout.style.setProperty('--value-prop-link-visibility', 'hidden');
      modal.querySelector('.modal-body').innerHTML = '';
      slideout.querySelector('.value-prop-link-content').innerHTML = '';
    }, 250);
  }

  document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector('.tw-pdp-value-prop-links');
    const modal = document.getElementById('value-prop-link-modal');
    const mask = document.getElementById('value-prop-link-slideout-mask');
    const triggers = document.querySelectorAll('[class^="value-prop-link-trigger-"]');
    triggers.forEach((trigger) => {
      const template = trigger.querySelector('template');
      trigger.addEventListener('click', () => {
        openFeatureDetail(template);
      });
    });

    modal.addEventListener('click', (e) => {
      if (e.target.id === 'feature-modal') {
        closeFeatureDetail();
      }
    });

    mask.addEventListener('click', closeFeatureDetail);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        closeFeatureDetail();
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tw-spec-links"] && !Shopify.designMode) return;
  try {
    const QUICK_LINK_ROOT_SELECTOR = '[data-tw-quick-links]';
  const QUICK_LINK_LIST_SELECTOR = '[data-tw-quick-links-list]';
  const QUICK_LINK_TARGET_SELECTOR = '[data-tw-quick-link-enabled="true"][data-tw-quick-link-label]';
  const GENERATED_LINK_SELECTOR = '[data-tw-quick-link-generated="true"]';

  const parsePixelValue = (value) => {
    if (!value) return 0;
    const parsed = Number.parseFloat(value.replace('px', '').trim());
    return Number.isNaN(parsed) ? 0 : parsed;
  };

  const getHeaderOffset = () => {
    const bodyStyles = window.getComputedStyle(document.body);
    const headerHeight = parsePixelValue(bodyStyles.getPropertyValue('--header-height'));
    const headerGroupHeight = parsePixelValue(bodyStyles.getPropertyValue('--header-group-height'));

    return Math.max(headerHeight, headerGroupHeight, 0);
  };

  const getLinkTargets = () => {
    const sectionElements = Array.from(
      document.querySelectorAll(`main .shopify-section ${QUICK_LINK_TARGET_SELECTOR}`),
    );

    const targets = [];
    const seen = new Set();

    sectionElements.forEach((element, index) => {
      const label = element.dataset.twQuickLinkLabel?.trim();
      const id = element.id?.trim();

      if (!label || !id || seen.has(id)) return;

      seen.add(id);

      const orderValue = Number.parseInt(element.dataset.twQuickLinkOrder || '', 10);

      targets.push({
        element,
        id,
        label,
        domIndex: index,
        order: Number.isNaN(orderValue) ? Number.MAX_SAFE_INTEGER : orderValue,
      });
    });

    targets.sort((first, second) => {
      if (first.order !== second.order) return first.order - second.order;
      return first.domIndex - second.domIndex;
    });

    return targets;
  };

  const buildListItem = ({ id, label }) => {
    const listItem = document.createElement('li');
    listItem.dataset.twQuickLinkGenerated = 'true';

    const anchor = document.createElement('a');
    anchor.href = `#${id}`;
    anchor.className = 'flex flex-nowrap justify-start items-center gap-1 group';

    const text = document.createElement('span');
    text.className =
      'text-body-three font-normal text-foreground-neutral-faded block group-hover:text-bg-foreground-neutral group-hover:transition-colors group-hover:duration-300 group-hover:ease-in-out duration-300 ease-in-out';
    text.textContent = label;

    const iconContainer = document.createElement('span');
    iconContainer.className =
      'group-hover:translate-x-1 group-hover:duration-300 group-hover:transition-[translate] duration-300 transition-[translate]';
    iconContainer.innerHTML =
      '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right" aria-hidden="true"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>';

    anchor.append(text, iconContainer);
    listItem.append(anchor);

    return listItem;
  };

  const updateTargetScrollMargin = (target, extraOffset = 0) => {
    const totalOffset = getHeaderOffset() + extraOffset;
    target.style.scrollMarginTop = `${Math.max(0, totalOffset)}px`;
  };

  const wireAnchorScrolling = (root, extraOffset = 0) => {
    root.addEventListener('click', (event) => {
      const anchor = event.target instanceof Element ? event.target.closest('a[href^="#"]') : null;
      if (!(anchor instanceof HTMLAnchorElement)) return;

      const hash = anchor.getAttribute('href');
      if (!hash || hash.length <= 1) return;

      const target = document.getElementById(hash.slice(1));
      if (!target) return;

      event.preventDefault();

      if (target instanceof HTMLButtonElement && target.hasAttribute('ref')) {
        target.click();
      }

      updateTargetScrollMargin(target, extraOffset);

      const offset = getHeaderOffset() + extraOffset;
      const top = window.scrollY + target.getBoundingClientRect().top - offset;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      window.scrollTo({
        top: Math.max(0, top),
        behavior: reduceMotion ? 'auto' : 'smooth',
      });

      window.history.replaceState(null, '', hash);
    });
  };

  const renderQuickLinks = () => {
    const roots = document.querySelectorAll(QUICK_LINK_ROOT_SELECTOR);
    const targets = getLinkTargets();

    roots.forEach((root) => {
      const list = root.querySelector(QUICK_LINK_LIST_SELECTOR);
      if (!(list instanceof HTMLElement)) return;

      const autoEnabled = root.dataset.twQuickLinksEnabled === 'true';
      const extraOffset = Number.parseInt(root.dataset.twQuickLinksExtraOffset || '0', 10) || 0;

      list.querySelectorAll(GENERATED_LINK_SELECTOR).forEach((node) => node.remove());

      if (autoEnabled) {
        targets.forEach((target) => {
          updateTargetScrollMargin(target.element, extraOffset);
          list.append(buildListItem(target));
        });
      }

      const totalItems = list.querySelectorAll('li').length;
      root.classList.toggle('hidden', totalItems === 0);

      if (root.dataset.twQuickLinksBound !== 'true') {
        wireAnchorScrolling(root, extraOffset);
        root.dataset.twQuickLinksBound = 'true';
      }
    });
  };

  const installQuickLinks = () => {
    renderQuickLinks();

    window.addEventListener('resize', renderQuickLinks, { passive: true });
    document.addEventListener('shopify:section:load', renderQuickLinks);
    document.addEventListener('shopify:section:unload', renderQuickLinks);
    document.addEventListener('shopify:section:reorder', renderQuickLinks);
  };

  if (!window.twQuickLinksInitialized) {
    window.twQuickLinksInitialized = true;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', installQuickLinks);
    } else {
      installQuickLinks();
    }
  }
  } catch(e) { console.error(e); }
})();

})();
